import classNames from "classnames";
import CuratedSearchDesignStepsContainer from "./CuratedSearchDesignSteps/CuratedSearchDesignStepsContainer";
import { useContext } from "react";
import AutopilotCuratedSearchContext from "../../contexts/AutopilotCuratedSearchContext";
import CiroCard from "../shared/CiroCard";
import CuratedSearchPromptSection from "./CuratedSearchPrompt/CuratedSearchPromptSection";
import { AutopilotFilterCreationTypeEnum } from "../../__generated__/graphql";

const CuratedSearchCriteriaAndFiltersContainer = ({
  filtersAndCriteriaMinimized,
  loading,
}: {
  filtersAndCriteriaMinimized: boolean;
  loading: boolean;
}) => {
  const { startedGeneratingFilters } = useContext(
    AutopilotCuratedSearchContext,
  );

  return (
    <div
      className={classNames(
        "transition-all",
        "duration-500",
        "ease-in-out",
        "overflow-hidden",
        "w-full",
        {
          "max-h-0": filtersAndCriteriaMinimized,
        },
      )}
    >
      {!startedGeneratingFilters && (
        <div className={classNames("text-sm", "text-zinc-500", "pb-4")}>
          Describe your desired search results
        </div>
      )}
      <div className={classNames("flex", "flex-col", "gap-4", "w-full")}>
        <div
          className={classNames("w-full", {
            "opacity-50": filtersAndCriteriaMinimized,
            "pointer-events-none": filtersAndCriteriaMinimized,
          })}
        >
          <CiroCard size="small">
            <div className={classNames("flex", "flex-col", "gap-4")}>
              <CuratedSearchPromptSection loading={loading} />
              {startedGeneratingFilters && (
                <CuratedSearchDesignStepsContainer
                  searchType={
                    AutopilotFilterCreationTypeEnum.CiroInternalGeneralFilters
                  }
                />
              )}
            </div>
          </CiroCard>
        </div>
      </div>
    </div>
  );
};

export default CuratedSearchCriteriaAndFiltersContainer;
